import React,{ Component, Fragment, use } from "react";
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import { getArrays } from 'lib';
import PropTypes from 'prop-types';
import moment from 'moment';
import { setCheckoutPlanParams, updateCheckoutPlanParams } from '../../store/checkoutPlanParams';
import { setCheckoutMealPlan,updateCheckoutMealPlan } from '../../store/checkoutMealPlan';
import { userUpdate } from '../../store/user';
import { spin, stop } from '../../store/spinner'; 
import Tabs from '../../components/Checkout/Tabs';
import BottomNav from '../../components/Checkout/BottomNav';
import Select from 'components/Select';
import { browserHistory } from "react-router";
import CheckIcon from 'assets/checkDiet.png';

class CheckoutStep1 extends Component{

    constructor(props) {
        super(props);
        const { user,checkoutMealPlan, checkoutPlanParams } = this.props;
        // console.log(socket);
        const { diet_id,id:checkoutId } = checkoutPlanParams || {};
        const { eliminate_groups,dislikes } = user;
        // if(checkoutId) browserHistory.push('/checkout/menus');
        if(checkoutMealPlan!=undefined && Object.keys(checkoutMealPlan).length>0) browserHistory.push('/checkout/menus');

       
        this.state={
            diet:diet_id || 32, // Default diet Athletes
            ingredientListData:[],
            dislikes: [],
            eliminate_groups: []
        }
    }
    componentDidMount(){
        const { socket } = this.props;
        if(socket.connected){
            this.initializeData();
        }else{
            socket.on('connect', (data) => {
                this.initializeData();
            });
        } 
    }
    initializeData =() =>{
        console.debug('Init Data');
        const { socket, dataArray,user } = this.props;
        const types = ['productsList','ingredientList','dietMobileList','dishGroups','planDayRange','daysRangeMob','mealtypeMobCombinations','typeList'].filter(el => !(el in dataArray));
        console.debug(types);
        if(types.length>0){
            this.props.spin();
            getArrays(socket, types);
        }
        const { id:checkoutId } = this.props.checkoutPlanParams || {};
        if(checkoutId){ browserHistory.push('/checkout/menus');}else{
            this.props.spin(); 
            this.getPending(user.user_id);
        }
    }
    setInitialState(){
        const { dataArray,user } = this.props;
        const { ingredientList,dishGroups } =dataArray;
        const { dislikes,eliminate_groups } = user;
        var dislikeList = (dislikes && ingredientList!=undefined)?this.formatSelectOption(dislikes,ingredientList):[];
        var eliminateList = (eliminate_groups && dishGroups!=undefined)?this.formatSelectOption(eliminate_groups,dishGroups):[];
        this.setState({'dislikes':dislikeList,'eliminate_groups':eliminateList});
    }
    componentWillMount() {
      this.props.socket.on('mobile_checkout', this.listener);
      this.props.socket.on('profile', this.listener);
    }
    componentWillUnmount() {
      this.props.socket.removeListener('mobile_checkout', this.listener);
      this.props.socket.removeListener('profile', this.listener);
    }
    getPending = user_id => this.props.socket.emit('mobile_checkout', { type: 'getPending', data: { user_id } });
    saveProfile = (data,action) =>{
        const { user } = this.props;
        if(user.token){
            this.props.socket.emit('profile', { type: 'getForDashboard', data: { userId: user.user_id, subtype: 'saveProfDataMobile', theaction: action, value: data,deviceType:'web'} });
        }else{
            let updateData = {};
            updateData[action] = data;
            this.props.updateUser(updateData);
        }
    }
    listener = ({ type, data, message }) => {
        this.props.stop(); 
        switch (type) {
           case 'saveProfDataMobileOk':
            const { value,action } = data || {};
            var updateData = {};
            updateData[action] = value;
            this.props.updateUser(updateData);
           break;
           case 'getPendingOk':
            this.setInitialState();
              const { setCheckoutPlanParams, setCheckoutMealPlan } = this.props;
              if(data && data.mealPlan !=undefined ){
                setCheckoutPlanParams(data.planParams);
                setCheckoutMealPlan(data.mealPlan);
                console.log(data.planParams);
                // browserHistory.push('/checkout/menus');
              }
            break;
           default:
           break;
        }
    }
    setDietType(diet){
        // console.log(dietId);
        this.setState({diet:diet.id});
    }
    renderDietTypes (){
        const { dataArray } = this.props;
        const { diet } = this.state;
        const dietPrices =['35.5 AED','37.5 AED','42.5 AED','45.5 AED'];
        let selectedIndex =null;
        let dietName =null;
        const dietMacros =[{'macros':' 300-500kcal | Protein-30-50g','macroscarb':' | Carbs- 20-50g | Fat- 10-25g','fat':'Fat: 25% - 45% | Protein: 30% - 50%','fatcarb':' | Carbs: 20% - 40%','portion':'Protein 120g | Carbs 80g','portioncarb':' | Vegetables 100g'},{'macros':' 450-650kcal | Protein 45-65g','macroscarb':' | Carbs 30-60g | Fat 15- 30g','fat':' Fat: 25% - 45% | Protein: 30% - 50% ','fatcarb':' | Carbs: 20% - 40%','portion':'Protein 160g | Carbs 100g','portioncarb':' | Vegetables 100g'},{'macros':'600-800 kcal | Protein 55-80g','macroscarb':' | Carbs 55-80g | Fat 15-30g','fat':' Fat: 25% - 45% | Protein: 30% - 50% ','fatcarb':' | Carbs: 25% - 50%','portion':'Protein 200g | Carbs 200g','portioncarb':' | Vegetables 100g'},{'macros':' 700-900kcal | Protein 65-85g','macroscarb':' | Carbs 65-90g | Fat 15- 35g','fat':'Fat: 15% - 40% | Protein: 30% - 50%','fatcarb':' | Carbs: 30% - 50%','portion':'Protein 220g | Carbs 250g','portioncarb':' | Vegetables 100g'}];
        const { dietMobileList, dietListByGroup } = dataArray;
        const list= dietMobileList && dietMobileList.map((value,index)=>{ 
            const handle = value.name.replace(/\s+/g, '-').toLowerCase();
            if(diet==value.id){
                selectedIndex =index;
                dietName=value.name;
            }
                return <li className={`diet-list ${(diet==value.id) ? 'diet-active' : ''}`} onClick={() => this.setDietType(value,handle)}>
                    <img src={require('assets/megafit-images/'+handle+'-ic.svg')} />
                    <span className='mainSpan'><span>{value.name}</span>
                    {(diet==value.id) && <i class="checkIcon fas fa-check-circle"></i>} 
                    <strong>{dietPrices[index]}<span> p/meal</span></strong></span>
                </li>
        });
        return <div className="step-form-group">
            <h3 class="font-weight-medium mb-3 pb-2">Diet Type</h3>
            <div className="step-form-input mb-4">
            <label class="mt-0 mb-2">Choose Type</label>
            <ul className="checkout-diet-list">
            {list}
        </ul>
        {selectedIndex!=null && dietMacros[selectedIndex] !=undefined &&<div className="meal_macros-proteins">
          <h5>{dietName}</h5>
          <div className="meal_macros_permeals">
            <p className="bodyreg font-weight-semibold heading_color">Macros per Meal</p>
            <div className="mead_info bodyspan font-weight-normal caption_color">
              {dietMacros[selectedIndex].macros}<br/>{dietMacros[selectedIndex].macroscarb}
            </div>
          </div>  
          <div className="meal_macros_permeals">
            <p className="bodyreg font-weight-semibold heading_color">Macros % Meal</p>
            <div className="mead_info bodyspan font-weight-normal caption_color">
            {dietMacros[selectedIndex].fat}<br/>{dietMacros[selectedIndex].fatcarb}
            </div>
          </div>    
          <div className="meal_macros_permeals">
            <p className="bodyreg font-weight-semibold heading_color">Portion per Meal</p>
            <div className="mead_info bodyspan font-weight-normal caption_color">
            {dietMacros[selectedIndex].portion}<br/>{dietMacros[selectedIndex].portioncarb}
            </div>
          </div>    
        </div>}</div></div>;
    }
    sortByName(list){
        return list!=undefined && Object.keys(list).sort((a,b)=>{
            const nameA = list[a].toUpperCase(); // ignore upper and lowercase
            const nameB = list[b].toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
       });
    }
    formatSelectOption(list,dataList){
        let ingredientListData = [];
        list!=undefined && list && list.map((val)=>{
            ingredientListData.push({label: dataList[val], value: parseInt(val)});
        });
        return ingredientListData;
    }
    renderPreference(){
        const { user, dataArray } = this.props;
        const { dislikes, eliminate_groups } = this.state;
        const { ingredientList, dishGroups } = dataArray;
        let ingredientList1 =this.sortByName(ingredientList);
        let ingredientListData = this.formatSelectOption(ingredientList1,ingredientList);
        let dishGroupList = dishGroups!=undefined ?this.formatSelectOption(Object.keys(dishGroups),dishGroups):[];
        var dislikeList = (user.dislikes && ingredientList!=undefined && dislikes.length==0)?this.formatSelectOption(user.dislikes,ingredientList):dislikes;
        var eliminateList = (user.eliminate_groups && dishGroups!=undefined && eliminate_groups.length==0)?this.formatSelectOption(user.eliminate_groups,dishGroups):eliminate_groups;
      
        return <Fragment><div className="step-form-group">
        <h3 className="font-weight-medium mb-3 pb-2">Preferences</h3>
        <div className="popup-select-area step-form-input mp4">
        <label className="food-prefs-header mb-2 mt-0">Eliminate</label>
        <div className={'className'}>
        <Select
          multiple={true}
          isgrouped={true}
          placeholder='Change Eliminate'
          list={dishGroupList}
          value={eliminateList || []}
          isSearchable={true}
          name='eliminate_groups'
          // onChange={e => this.changeDislike('dislikes',e)}
          onChange={ (name, val) => {
            // console.log(val);
           // this.changeDislike('dislikes', val);
           this.setState({
           'eliminate_groups': val
          });
          this.saveProfile(val.map((value)=>{ return parseInt(value.value);}),'eliminate_groups');
          }}
        />
      </div>
      </div>
        <div className="popup-select-area step-form-input mp4">
        <label className="food-prefs-header mb-2 mt-0">Dislikes</label>
        <div className={'className'}>
        <Select
          multiple={true}
          isgrouped={true}
          placeholder='Change Dislikes'
          list={ingredientListData}
          value={dislikeList || []}
          isSearchable={true}
          name='dislikes'
          // onChange={e => this.changeDislike('dislikes',e)}
          onChange={ (name, val) => {
            // console.log(val);
           // this.changeDislike('dislikes', val);
           this.setState({
           'dislikes': val
          });
        //   console.log(val.map((value)=>{ return parseInt(value.value);}));
          this.saveProfile(val.map((value)=>{ return parseInt(value.value);}),'dislikes');
          }}
        />
      </div>
      </div>
      <p className="note">*Note: Certain ingredients cannot be avoided and if more than three, please consult.</p>
      </div></Fragment>;
    }
    validate = ()=>{
        // const { diet } = this.state;
        // const { updateCheckoutPlanParams, setCheckoutPlanParams,checkoutPlanParams, dataArray } = this.props;
        // const { dietMobileList } = dataArray;
        // if(!diet){
        //     alert('Please select diet type to continue');
        //     return false;
        // }else{
        //     let mealTypeList = dietMobileList.filter((value)=>(value.id ==diet  && value.mealtypes)); 
        //     // console.log('mealTypeList');
        //     // console.log(mealTypeList);
        //     if(mealTypeList[0].mealtypes.length<=0){
        //         alert("Please select different diet type. Currently, don't have meals");
        //         return false;
        //     }else{
        //         checkoutPlanParams && updateCheckoutPlanParams({ 'diet_id': diet, modified: true });
        //         !checkoutPlanParams && setCheckoutPlanParams({ 'diet_id': diet, modified: true });
        //     }
            
        // }
        return true;
    }
    render() {
        
        // console.log(dietMobileList);
        return <Fragment>
            <div className="main-holder checkout-process-con wrap-progress-page" >
                        <div className="container checkout-process step1">
                        <div className="row">
                        <div className='col-12'>
                           <Tabs />
                           <div className="inner-content">
                            <h2 className="mobile-header">Preference</h2>
                                {/* {this.renderDietTypes()} */}
                                {this.renderPreference()}
                           </div>
                           <BottomNav isLogin={this.props.user.token} continueValid={this.validate} />
                        </div>
                        </div>
                    </div>
              </div>
        </Fragment>
    }
}
CheckoutStep1.propTypes = {
    checkoutPlanParams: PropTypes.object.isRequired,
    checkoutMealPlan: PropTypes.object.isRequired,
    setCheckoutMealPlan: PropTypes.func.isRequired,
    setCheckoutPlanParams: PropTypes.func.isRequired,
    dataArray: PropTypes.object.isRequired
};
  
const mapStateToProps = state => ({
    checkoutPlanParams: state.checkoutPlanParams,
    dataArray: state.dataArray,
    user:state.user,
    checkoutMealPlan: state.checkoutMealPlan
});

const bindAction = dispatch => ({
    setModal: obj => dispatch(setModal(obj)),
    setCheckoutMealPlan: plan => dispatch(setCheckoutMealPlan(plan)),
    setCheckoutPlanParams: obj => dispatch(setCheckoutPlanParams(obj)),
    updateCheckoutPlanParams: obj => dispatch(updateCheckoutPlanParams(obj)),
    spin: () => dispatch(spin()),
    stop: () => dispatch(stop()),
    updateCheckoutMealPlan: (date,obj) => dispatch(updateCheckoutMealPlan(date,obj)),
    updateUser: user => dispatch(userUpdate(user)),
    setModal: obj => dispatch(setModal(obj))
});
  
export default socketConnect(connect(mapStateToProps, bindAction)(CheckoutStep1));